module.exports = __webpack_public_path__ + "static/media/img-heritage-area6-gloverhouse.fccd840b.jpg";